import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/phoenix-squadron': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M96 63.4c46.5-36.1 105.5-56.1 164.5-54.6 29.6-0.4 59.1 5.4 86.9 15.3-24.1-4.6-49-6.3-73.4-2.4-42.9 5.3-83 27.1-111.8 59.2 5.7-1 10.8-3.7 16-5.9 18.1-7.9 37.5-13.3 57.2-14.8 19.7-2.1 39.6-0.4 59.3 1.9-14.4 2.8-29.1 4.6-43 9.6-34.4 11.1-65.3 33.2-86.3 62.6-13.8 19.7-23.6 42.9-24.7 67.1-0.3 16.5 5.2 34.8 19.8 44 7 4.2 19.4 7.7 27.6 7.7 2.8 0 7.2-0.4 10-0.9 15.5-2.5 30.1-8.6 43.6-16.3 11.5-6.8 22.7-14.6 32-24.3 3.8-3.2 2.5-8.5 2.6-12.8-2.1-0.3-4.4-1.1-6.3 0.3-9.5 5.2-25.5 12.1-35.8 15.4-20 6.2-42.2 8.5-62.1 0.8 12.8 1.7 26.1 0.3 37.7-5.4 20.2-9.7 36.8-25.2 54.4-38.8 23-17.7 62.8-42.5 88.9-55.3 25.7-12 52.9-22.8 81.6-24.1-15.6 13.7-32.2 26.5-46.8 41.4-14.5 14-27.5 29.5-40.1 45.2-3.5 4.6-9 6.9-13.6 10.2-18.9 12.7-42.1 39.6-51.9 60.1-9.3 19.7-14.5 41.8-11.8 63.6 1.9 13.7 8.7 27.6 20.9 34.9 12.9 8 29.1 8.1 43.5 5.1 32.8-7.5 61.4-28.9 81-55.8 20.4-27.5 30.5-62.2 29.2-96.3-0.5-7.5-1.6-15-1.7-22.5 8 19.5 14.8 39.7 16.7 60.8 2 14.3 0.8 28.8-1.6 42.9-1.9 11-5.7 21.5-7.8 32.4 17.2-19.3 34.8-55.6 39.3-81.1 1.2-7.9 2.2-20.7 2.2-28.7 0-22-7.4-56-16.5-76 20.8 32 32.3 69.6 35.7 107.5 0.5 12.7 0.5 25.5 0 38.2-2.4 28.7-15.6 72.5-29.6 97.8-26.1 47.3-68 85.6-117.2 108-78.3 36.2-174.7 31.3-248-14.7-32.9-20.1-73.9-64.3-91.4-98.7-12.3-24.2-23.7-65.8-25.4-92.9v-31.3c3.9-69.7 40.9-135.9 96-178.4zM318 143.7c4.5-0.8 11.7-2.8 16-4.5 5-1.8 9.2-5.9 10.3-11.2-9 5-18 9.9-26.3 15.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/phoenix-squadron.js
// module id = 967
// module chunks = 0